/**
 * SheetJS (xlsx) shim for Tabulator's `download("xlsx", …)`.
 *
 * Tabulator's xlsx downloader looks for a global `XLSX` on `window` at
 * call time — it does NOT import SheetJS itself (it's a peer dep). We
 * import the module once here and attach it to `window` so any
 * Tabulator grid in the app can call `table.download("xlsx", …)`
 * without each grid having to wire its own dependency.
 *
 * SheetJS is pinned in package.json to the CDN tarball
 * `https://cdn.sheetjs.com/xlsx-0.20.3/xlsx-0.20.3.tgz` (SheetJS doesn't
 * publish to npm; this is their canonical install path). The named
 * import below resolves through Vite's normal module graph.
 *
 * Imported from app/frontend/grids/bootstrap.js so the shim is loaded
 * exactly once, alongside Tabulator itself, before any grid mounts.
 *
 * GH #277 — Excel export for the combined-lots grid (first user of
 * this shim; future grids that need xlsx export get it for free).
 */
import * as XLSX from 'xlsx';

window.XLSX = XLSX;
